// Acceso seguro al almacenamiento del navegador. Chrome puede bloquear localStorage /
// sessionStorage (datos de sitio bloqueados, modo invitado, políticas de empresa) y en ese caso
// getItem/setItem LANZAN una excepción: dentro de un render eso deja la pantalla en blanco.
const make = (getStore) => ({
  getItem(k) { try { return getStore().getItem(k); } catch (e) { return null; } },
  setItem(k, v) { try { getStore().setItem(k, v); } catch (e) { /* sin almacenamiento: se ignora */ } },
  removeItem(k) { try { getStore().removeItem(k); } catch (e) { /* idem */ } },
});
export const safeLS = make(() => window.localStorage);
export const safeSS = make(() => window.sessionStorage);
